module.exports = __webpack_public_path__ + "img/digital-agency.cf6f2db5.webp";